// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.links-content {
    position: relative;
    z-index: 1;
    padding: 20px;
    color: black; /* Change text color to ensure visibility */
  }`, "",{"version":3,"sources":["webpack://./src/pages/Links/Links.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,YAAY,EAAE,2CAA2C;EAC3D","sourcesContent":[".links-content {\n    position: relative;\n    z-index: 1;\n    padding: 20px;\n    color: black; /* Change text color to ensure visibility */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
